import { createFileRoute } from '@tanstack/react-router'

import { handoverGate } from '@/features/handover/gate'
import { LicenceCapture } from '@/features/licences/licence-capture'
import { licenceCaptureSearchSchema } from '@/features/licences/licence-capture-search'

/** The licence check, at `/bookings/{id}/licence`. `?recheck=true` re-checks a licence on file. */
export const Route = createFileRoute('/_app/bookings/$bookingId_/licence')({
  ...handoverGate({ search: licenceCaptureSearchSchema }),
  component: LicenceCapture,
})
